var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper notification-settings" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("search.allNotificationSettings"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("notification.notificationSettingsDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c(
            "a-collapse",
            {
              staticClass: "notification-collapse",
              attrs: { bordered: false },
              model: {
                value: _vm.activeKeys,
                callback: function ($$v) {
                  _vm.activeKeys = $$v
                },
                expression: "activeKeys",
              },
            },
            _vm._l(_vm.groups, function (group) {
              return _c(
                "a-collapse-panel",
                { key: group.id, attrs: { header: group.title } },
                [
                  _c("BasicActions", {
                    attrs: {
                      settings: _vm.settings,
                      title: group.title,
                      "allowed-scopes": group.allowedScopes,
                    },
                    on: { update: _vm.updateScopeNotificationSettings },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }